var map = {
	"./locale-provider/ar_EG.tsx": 1079,
	"./locale-provider/bg_BG.tsx": 1083,
	"./locale-provider/ca_ES.tsx": 1087,
	"./locale-provider/cs_CZ.tsx": 1091,
	"./locale-provider/de_DE.tsx": 1095,
	"./locale-provider/el_GR.tsx": 1099,
	"./locale-provider/en_GB.tsx": 1103,
	"./locale-provider/en_US.tsx": 1107,
	"./locale-provider/es_ES.tsx": 1108,
	"./locale-provider/et_EE.tsx": 1112,
	"./locale-provider/fa_IR.tsx": 1116,
	"./locale-provider/fi_FI.tsx": 1120,
	"./locale-provider/fr_BE.tsx": 1124,
	"./locale-provider/fr_FR.tsx": 1128,
	"./locale-provider/is_IS.tsx": 1132,
	"./locale-provider/it_IT.tsx": 1136,
	"./locale-provider/ja_JP.tsx": 1140,
	"./locale-provider/ko_KR.tsx": 1144,
	"./locale-provider/ku_IQ.tsx": 1148,
	"./locale-provider/nb_NO.tsx": 1152,
	"./locale-provider/nl_BE.tsx": 1156,
	"./locale-provider/nl_NL.tsx": 1160,
	"./locale-provider/pl_PL.tsx": 1164,
	"./locale-provider/pt_BR.tsx": 1168,
	"./locale-provider/pt_PT.tsx": 1172,
	"./locale-provider/ru_RU.tsx": 1176,
	"./locale-provider/sk_SK.tsx": 1180,
	"./locale-provider/sl_SI.tsx": 1184,
	"./locale-provider/sr_RS.tsx": 1187,
	"./locale-provider/sv_SE.tsx": 1191,
	"./locale-provider/th_TH.tsx": 1195,
	"./locale-provider/tr_TR.tsx": 1199,
	"./locale-provider/uk_UA.tsx": 1203,
	"./locale-provider/vi_VN.tsx": 1207,
	"./locale-provider/zh_CN.tsx": 1211,
	"./locale-provider/zh_TW.tsx": 1214
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1078;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 1078
// module chunks = 0